export default __webpack_public_path__ + "static/media/VectorRed.d28f18f3.svg";